module.exports = __webpack_public_path__ + "img/cloud-showers-heavy.50ae3dbc.svg";